const resources = {
  colors: require('./colors').colors,
  drawables: require('./drawables').drawables,
};

export const R = {
  drawables: resources.drawables,
  colors: resources.colors
};
